import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { citySlug } from '@/hooks/useNeighborhoods';

interface Props {
  cityName: string;
  neighborhood: {
    id: string;
    name: string;
    slug: string;
    tagline?: string | null;
    cover_image_url?: string | null;
  };
}

export function NeighborhoodCard({ cityName, neighborhood }: Props) {
  return (
    <Link
      to={`/area-guides/${citySlug(cityName)}/${neighborhood.slug}`}
      className="group block overflow-hidden rounded-lg border bg-card hover:shadow-lg transition-shadow"
    >
      <div className="aspect-[4/3] overflow-hidden bg-muted">
        {neighborhood.cover_image_url && (
          <img
            src={neighborhood.cover_image_url}
            alt={neighborhood.name}
            loading="lazy"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        )}
      </div>
      <div className="p-4">
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-1">
          <MapPin className="h-3 w-3" />
          {cityName}
        </div>
        <h3 className="font-semibold text-base mb-1">{neighborhood.name}</h3>
        {neighborhood.tagline && (
          <p className="text-sm text-muted-foreground line-clamp-2">{neighborhood.tagline}</p>
        )}
        <div className="mt-3 inline-flex items-center text-sm font-medium text-primary group-hover:gap-2 gap-1 transition-all">
          View area guide <ArrowRight className="h-3.5 w-3.5" />
        </div>
      </div>
    </Link>
  );
}
